(function () {
    angular
        .module('appback')
        .directive('ngAnaliticaLoader', analiticaLoader);

    analiticaLoader.$inject = ['$http', '$compile'];

    function analiticaLoader($http, $compile) {
        return {
            restrict: 'EA', // Elemento o Atributo
            // Scope aislado: Recibimos TODO lo que podrían necesitar las directivas hijas
            scope: {
                item: '=',
                rc: '=',        // Según tu código, rc contiene animal, centro, etc.
                peticion: '=',
                centro: '=',
                categoria: '=',
                animal: '='
            },
            link: function (scope, element, attrs) {
                //console.log("analiticaloader", scope);
                // 1. Obtenemos el identificador para preguntar al PHP
                var tipoFormulario = scope.item.analitica.formulario_resultado;
                var data = $.param({
                    tipo: tipoFormulario
                });
                // 2. Llamamos al PHP para obtener el HTML de la directiva correspondiente
                $http.post('/backend/resultadopeticion/analiticaloader', data)
                    .then(function (response) {
                        // El PHP debe devolver un string como: 
                        // '<div ng-proteinograma item="item" rc="rc"></div>'
                        var htmlDirectiva = response.data;

                        // 3. Insertamos el HTML
                        element.html(htmlDirectiva);

                        // 4. COMPILAMOS. Esto conecta el scope actual (item, rc, etc.) 
                        // con el HTML insertado.
                        $compile(element.contents())(scope);
                    })
                    .catch(function (err) {
                        console.error("Error obteniendo directiva", err);
                    });
            }
        };
    }
})();